import { DEMANDS_FILTER_MIN_DATE } from '../../../Catalog/Consts/demands-filter-panel.const';
import { DemandsDateRangeChange } from '../../../Catalog/Interfaces/demands-filter-panel.interface';
import { formatDateOnly } from '../../../Catalog/Shared/date-only.util';
import { MONITORING_DEFAULT_RANGE_MONTHS } from '../Consts/monitoring-range.const';

export function buildDefaultMonitoringRange(today: Date = new Date()): DemandsDateRangeChange {
  const monthStart = new Date(
    today.getFullYear(),
    today.getMonth() - MONITORING_DEFAULT_RANGE_MONTHS,
    1,
  );
  const lastDayOfMonth = new Date(monthStart.getFullYear(), monthStart.getMonth() + 1, 0).getDate();
  const from = new Date(monthStart);
  from.setDate(Math.min(today.getDate(), lastDayOfMonth) + 1);

  const clampedFrom = from > DEMANDS_FILTER_MIN_DATE ? from : DEMANDS_FILTER_MIN_DATE;

  return { from: formatDateOnly(clampedFrom), to: formatDateOnly(today) };
}
